/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display.Align
 */

module.exports = {

    In: require('./in'),
    To: require('./to')

};



//////////////////
// WEBPACK FOOTER
// ./display/align/index.js
// module id = 489
// module chunks = 0